import { useLocale } from '@koopajs/react';
import { TablePagination, Box } from '@mui/material';
import { useCallback } from 'react';
import { IApprovedTopic } from 'types';
import { InCameraCard } from './InCameraCard';

interface IInCameraListProps {
  inCameraList: IApprovedTopic[];
  size?: number;
  page?: number;
  totalCount?: number;
  isReloading: boolean;
  onPageChange: (page: number) => void;
  onSizeChange: (size: number) => void;
}

export const InCameraList: React.FC<IInCameraListProps> = (props) => {
  const { inCameraList, size, page, totalCount, isReloading, onPageChange, onSizeChange } = props;

  const { t } = useLocale();

  const handlePageChange = useCallback(
    (e: unknown, newPage: number) => {
      onPageChange(newPage);
    },
    [page]
  );

  const handleSizeChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onSizeChange(Number(e.target.value)),
    []
  );

  return (
    <>
      <Box sx={{ opacity: isReloading ? 0.35 : 1 }}>
        {inCameraList.map((inCamera) => {
          return <InCameraCard key={inCamera.id} inCamera={inCamera} />;
        })}
      </Box>
      <TablePagination
        rowsPerPageOptions={[5, 20, 50]}
        component="div"
        // sx={{ display: { xs: 'none', md: 'block' } }}
        count={totalCount || 999}
        rowsPerPage={size || 20}
        page={page ? page : 0}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleSizeChange}
        SelectProps={{
          native: true
        }}
        // eslint-disable-next-line react/jsx-no-bind
        labelDisplayedRows={({ from, to, count }) => {
          const transOptions = { from, to, count };

          return count !== -1
            ? t('common:TablePagination.labelDisplayedRowsCount', transOptions)
            : t('common:TablePagination.labelDisplayedRowsMoreThan', transOptions);
        }}
        labelRowsPerPage={t('common:TablePagination.labelRowsPerPage')}
      />
    </>
  );
};
